module.exports = __webpack_public_path__ + "static/media/headshot.3ee94be9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/App/images/headshot.JPG
// module id = 80
// module chunks = 0